import { SET_SPORTSBOOK_ACTIVE_FILTERS } from 'Store/constants';

export default (state = {}, action) => {
  switch (action.type) {
    case SET_SPORTSBOOK_ACTIVE_FILTERS:
      return {
        ...state,
        ...action.payload
      };

    default:
      return state;
  }
};
